import view from "../../views/lobby";
import KTAPI from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";


import { _user, _handler, getPingColor, getEloLevel, sanitizeHTML, Countdown} from "../classes/index.classes";
import { ioPings } from "../mm/index.mm";


const LOBBY_STATUS_CREATED = 0;
const LOBBY_STATUS_WAITING = 1;
const LOBBY_STATUS_READY = 2;
const LOBBY_STATUS_VETOMAP = 3;
const LOBBY_STATUS_CONFIGURING = 4;
const LOBBY_STATUS_LAUNCHING = 5;
const LOBBY_STATUS_STARTED = 6;
const LOBBY_STATUS_PLAYING = 7;
const LOBBY_STATUS_FINISHED = 8;

const LOBBY_STATUS = {
    0: "Created",
    1: "Waiting",
    2: "Ready",
    3: "Veto Map",
    4: "Configuring",
    5: "Launching",
    6: "Started",
    7: "Playing",
    8: "Finished",
}

let lobby = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {    
        
        //if(data.msg !== undefined) { //hay mensaje de error
            
        //    return;
        //}
        
        //console.log(data);


        
        if(!_user.authed)
        {  

        }
        else
        {            
            

        }

        let id = data._id;

        KTAPI.getLobby(id).then(data => {
            if(data.message == 'done')
            {
                renderLobby(data.lobby);
            }
        });

        //renderLobby(data);
        


        KTScroll.init();

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};

let lobbyTimer = null;


$(document).ready(function(){    
    $(document).on("click", "#lobby-share-url",async function() {   
        $("#lobby-btn-share").trigger("click");
    });

    $(document).on("click", ".lobby-join",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        ioSocket.socket.emit("lobby-join", {lobby: $(this).data("info")._id, team: $(this).data("team") === undefined ? 'random' : $(this).data("team")});
    });

    $(document).on("click", ".lobby-leave",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        ioSocket.socket.emit("lobby-leave", {lobby: $(this).data("info")._id});
    });

    $(document).on("click", ".lobby-cancel",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        ioSocket.socket.emit("lobby-destroy", {lobby: $(this).data("info")._id});
    });

    $(document).on("click", ".lobby-take-slot",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        if(_user.inLobby && _user.lobbyInfo._id == $(this).data("info")._id)
        {
            ioSocket.socket.emit("lobby-player-set-team", {lobby: $(this).data("info")._id, team: $(this).data("team")});
        }
        else if(!_user.inLobby)
        {
            ioSocket.socket.emit("lobby-join", {lobby: $(this).data("info")._id, team: $(this).data("team")});
        }
        
    });

    $(document).on("click", ".lobby-change-team",async function() {   
        if(!_user.authed) return;
        
        //let res = null;        
        //res = await new Promise(resolve => ioSocket.socket.emit('lobby-join', {lobby: $(this).data("info")._id}, data => resolve(data)));
        if(_user.inLobby && _user.lobbyInfo._id == $(this).data("info")._id)
        {
            let xteam = _user.lobbyInfo.players[_user.me.steamid].team == 'A' ? 'B' : 'A';
            ioSocket.socket.emit("lobby-player-set-team", {lobby: $(this).data("info")._id, team: xteam});
        }       
        
    });


    $(document).on("click", ".lobby-host-kick-player",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        ioSocket.socket.emit("lobby-host-kick-player", {lobby: $(this).data("info")._id, player: $(this).data("player")});
    });

    $(document).on("click", ".lobby-host-ban-player",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;    
        ioSocket.socket.emit("lobby-host-ban-player", {lobby: $(this).data("info")._id, player: $(this).data("player")});
    });

    $(document).on("click", ".lobby-host-change-team",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;

        let xteam = $(this).data("player").team == 'A' ? 'B' : 'A';
        console.log("Host changing", $(this).data("player").steamid, "to TEAM", xteam);
        ioSocket.socket.emit("lobby-host-change-player-team", {lobby: $(this).data("info")._id, team: xteam, player: $(this).data("player")});
        
    });

    $(document).on("click", ".lobby-prev-map",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
                
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {maps: 'prev-map'}});
        
    });

    $(document).on("click", ".lobby-next-map",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
                
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {maps: 'next-map'}});
        
    });
    
    $(document).on("change", "#lobby-knife-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {knife: bool}});
        
    });

    $(document).on("change", "#lobby-ot-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {ot: bool}});
        
    });

    $(document).on("change", "#lobby-ff-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {ff: bool}});
        
    });

    $(document).on("change", "#lobby-eq-switch",async function() {   
        if(!_user.authed) return;
        if(_user.me.steamid !== $(this).data("info").creator) return;
        let bool = this.checked;
        ioSocket.socket.emit("lobby-host-settings", {lobby: $(this).data("info")._id, settings: {eq: bool}});
        
    });

    $(document).on("click", ".lobby-player-ready",async function() {   
        if(!_user.authed) return;        
                
        ioSocket.socket.emit("lobby-player-ready", {lobby: $(this).data("info")._id});
        
    });

    $(document).on("click", ".lobby-host-start",async function() {   
        if(!_user.authed) return;        
                
        ioSocket.socket.emit("lobby-host-go", {lobby: $(this).data("info")._id});
        
    });


    $(document).on("click", ".lobby-vote-map-option",async function(e) {   
        if(!_user.authed) return;
        if(!$(this).hasClass("votable")) return;
        e.preventDefault();
        $(this).addClass("disabled");
        let res = await KTAPI.voteMap({lobbyId: $(this).data("lobby-id"), map: $(this).data("map")});
        //ioSocket.socket.emit("lobby-vote-map", {lobby: $(this).data("info")._id, map: $(this).data("map")});
        console.log(res);
        
    });
});



/**
 * 
 * SOCKET.IO PROCESSES
 * 
 */


const lobbySocket = (socket) => {

    socket.on("player-join-lobby", async (data) => {
        //console.log("Player join lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);
    });

    socket.on("player-leave-lobby", async (data) => {
        //console.log("Player left lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);        
    });

    socket.on("player-kick-lobby", async (data) => {
        //console.log("Player left lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(data.player.steamid === _user.me.steamid)
        {
            errorMsg({title: "Ooops!", content: "You have been kicked from the lobby"});
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);        
    });

    socket.on("player-ban-lobby", async (data) => {
        //console.log("Player left lobby", data);
        $("[data-pmenu=true]").remove(); //p menus de lobbies
        if(data.player.steamid === _user.me.steamid)
        {
            errorMsg({title: "Ooops!", content: "You have been banned from the lobby"});
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id)) renderLobby(data.lobby);
    });

    socket.on("player-change-team", async (data) => {
        //console.log("Player", data.player, "changed to side", data.team);
        if(_user.lobbyInfo._id === data.lobby._id)
        {
            _user.lobbyInfo.players[_user.me.steamid].team = data.lobby.players[_user.me.steamid].team;
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            $("[data-pmenu=true]").remove(); //p menus de lobbies
            renderTeams(data.lobby);
        } 
        
    });

    socket.on("player-change-info", async (data) => {
        //console.log("Player", data.player, "changed to side", data.team);
        if(_user.lobbyInfo._id === data.lobby._id)
        {
            _user.lobbyInfo.players[_user.me.steamid] = data.lobby.players[_user.me.steamid];
        }
        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            $("[data-pmenu=true]").remove(); //p menus de lobbies
            renderTeams(data.lobby);
            renderFeatures(data.lobby);
        } 
        
    });

    socket.on("lobby-closed", async (data) => {

        if(_user.authed){
            _user.inLobby = false;
            _user.lobbyInfo = {};
            
        }
        if(data.creator === _user.me.steamid){
            errorMsg({title: "Ooops!", content: "The lobby has been removed"});
        }
        else
        {            
            errorMsg({title: "Ooops!", content: "The host has removed the game lobby"});
        }
        
        if(router.getCurrentLocation().url.includes(data._id))
        {
            console.log("lobby closed");
            $("#lobby-list-empty").addClass("d-none"); //bug?
            router.navigate("play");
        }

        
    });

    socket.on("lobby-destroyed", async (data) => {
        if(router.getCurrentLocation().url.includes(data.lobby._id) && !(_user.authed && data.lobby.players.hasOwnProperty(_user.me.steamid)))
        {            
            errorMsg({title: "Ooops!", content: "The host has removed the game lobby"});
            console.log("lobby destroyed");
            router.navigate("play");
        }
    });

    socket.on("lobby-update-settings", async (data) => {

        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            console.log("lobby new settings");
            renderFeatures(data.lobby);
        }

    });


    socket.on("lobby-preparing", async (data) => {

        errorMsg({title: "Yeah!", content: "Game is preparing"});
        console.log("lobby preparing");

    });

    socket.on("lobby-ongoing", async (data) => {

        errorMsg({title: "Yeah!", content: "Game is ongoing"});
        console.log("lobby ongoing");

    });

    socket.on("lobby_status_changed", async (data) => {            
        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            renderByStatus(data.lobby.status, data.lobby);
        }
    });

    socket.on("map_veto_started", async (data) => {
        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            console.log("map veto started");
            $(".lobby-step-container").text("Veto map is Starting...");
            lobbyTimer == null ? lobbyTimer = new Countdown({displayElement: '.lobby-step-timer', seconds: 5}) : lobbyTimer.setSeconds(5);
            renderMapVeto(data.lobby, data.maps);
        }
    });

    socket.on("map_veto_turn", async (data) => {
        if(router.getCurrentLocation().url.includes(data.lobby._id))
        {
            console.log("map veto turn");
            //$(".lobby-step-container").text("Veto map is on turn...");
            lobbyTimer == null ? lobbyTimer = new Countdown({displayElement: '.lobby-step-timer', seconds: 20}) : lobbyTimer.setSeconds(20);
            renderMapVeto(data.lobby, data.maps, data.turn, data.leader);
        }
    });

    socket.on("map_veto_map_removed", async (data) => {
        if(router.getCurrentLocation().url.includes(data.lobbyId))
        {
            console.log("map veto map removed", data.map);
            $(".lobby-vote-map-option").each(function(){
                if($(this).data("map") === data.map)
                {
                    //$(this).addClass("disabled");
                    $(this).remove();
                }
            });
            //renderMapVeto(data.lobby, data.maps, data.leader);
        }
    });

    socket.on("map_veto_complete", async (data) => {
        console.log("map veto complete", data.map);
        $(".lobby-step-container").text("Veto map is complete");
        $(".lobby-vote-map-option").removeClass("votable").addClass("cursor-default");
    });

};

export {lobbySocket};


/**
 * 
 * RENDER FUNCTIONS
 * 
 */

const colorType = {
    mm: "primary",
    scrim: "info",
    pug: "success",
}

export function renderLobby(data){

    //renderLobbyButtons(data);
    
    $(".lobby-title").text(data.title);
    $("#lobby-badge-type").addClass(data.type !== undefined ? `badge-${colorType[data.type]}` : "").text(data.type);
    $(".lobby-vs").text(data.vs);
    //$("#lobby-map-img").attr("src", `assets/media/maps/1080px/${data.maps[0]}.jpg`);
    $(".lobby-team-A-name").text(data.teamAname || "TEAM_A");
    $(".lobby-team-B-name").text(data.teamBname || "TEAM_B");
    
    //let rn = 2//Math.floor(Math.random() * 3)
    $("#lobby-logo-teamA").attr("src", data.players.find(p => p.steamid === data.teamALeader).user.avatar);
    $("#lobby-logo-teamB").attr("src", data.players.find(p => p.steamid === data.teamBLeader).user.avatar);
    $("lobby-server.region").html(`<img class="me-1" src="assets/media/flags/${data.location}.gif"><span class="fw-bold text-gray-900 fs-7">${data.region}</span>`)
    
    let promRatingteamA = data.teamA.map(steamid => data.players.find(p => p.steamid === steamid).rating).reduce((a,b) => a + b, 0) / data.teamA.length;
    let promRatingteamB = data.teamB.map(steamid => data.players.find(p => p.steamid === steamid).rating).reduce((a,b) => a + b, 0) / data.teamB.length;
    $(".lobby-teamArating").text(promRatingteamA);
    $(".lobby-teamBrating").text(promRatingteamB);

    $(".lobby-server-region").html(`<img class="me-1" src="assets/media/flags/${data.location}.gif" style="vertical-align: middle"><span class="fw-bold text-gray-900 fs-7">${data.region}</span>`);
    $(".lobby-server-ping").html(`<span class="text-gray-700"><span><i class="bi bi-bar-chart-fill pe-0 ${getPingColor(ioPings[data.location] === undefined ? 9999 : ioPings[data.location])}" data-iconping="${data.location}"></i>
                <span class="fw-bold fs-7 my-1 text-nowrap" data-showping="${data.location}">${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? `<div    class="spinner-border text-primary text-center" role="status" style="width: 11px; height: 11px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[data.location].ping}</span></span>
                <span class="fs-7">ms</span></span>`);


    $(".lobby-server-status").html(`<span class="badge badge-light fs-8 text-nowrap">${LOBBY_STATUS[data.status]}</span>`);
    //$("#lobby-share-url").text(`${window.location}`);
    
    //renderFeatures(data);
    //renderTeams(data);

    renderTeamsDetailed(data);

    router.updatePageLinks();
}

export function renderPlayerDetailed(steamid, lobby = {}){
    
    let player = lobby.players.find(p => p.steamid === steamid);
    let crown = `<i class="fas fa-crown fs-7 text-zyellow position-absolute ms-auto me-auto start-0 end-0 text-center" style="top:-6px"></i>`;
    let host = lobby.creator === steamid ? true : false;
    let leader = lobby.teamALeader === steamid || lobby.teamBLeader === steamid ? true : false;

    let html = /* html */`

        <div class="card mb-4 player-slot" data-steamid="${steamid}">
            <div class="card-body p-5">
                <div class="d-flex flex-stack">
                    <div class="d-flex align-items-center">
                        <div class="position-relative me-3 symbol symbol-40px ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${player.steamid}">
                            ${leader ? crown : ''}
                            <img src="${player.user.avatar === undefined ? "assets/media/avatars/default.jpg" : player.user.avatar}" class="" alt="">
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <a href="user/${player.user.communityid}" href="_blank" class="text-gray-700 fw-bolder text-hover-white fs-7 lh-2 text-nowrap text-truncate mw-150px mw-md-auto">${player.user.nickname === undefined ? player.user.steamid.replace("BOT:", "") : sanitizeHTML(player.user.nickname)}</a>
                            <div class="d-flex flex-row gap-2 lh-3 text-gray-600 fw-bold fs-6">
                                
                                <div class="d-flex align-self-center" title="${player.user.city} ${player.user.country}" data-toggle="tooltip">
                                    <img class="w-20px" src="assets/media/flags/${player.user.countrycode.toLowerCase()}.gif">
                                </div>
                                <div class="d-flex align-self-center" title="${player.user.steamid}" data-toggle="tooltip">
                                    <a class="text-hover-white lh-1" href="https://steamcommunity.com/profiles/${player.user.communityid}/" target="_blank">
                                        <i class="fab fa-steam fs-4"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center">
                    <span class="badge fw-bold text-white fs-7" style="background-color: #151515;" data-toggle="tooltip" title="Rating">${player.rating}</span>
                        <div class="symbol symbol-40px ms-2" data-toggle="tooltip" title="${getEloLevel(player.rating, player.rd).level} stars">
                            <img alt="Pic" src="assets/media/ranks/rank_${getEloLevel(player.rating, player.rd).level}.png">
                        </div>                                
                    </div>
                </div>
            </div>
            <div class="card-footer px-5 py-4 d-flex justify-content-between gap-4">                        
                <div class="d-flex align-items-center me-2" data-toggle="tooltip" title="Matches won percentage">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-30px me-3">
                        <div class="symbol-label bg-transparent">
                            <i class="fad fa-swords fs-2 text-success"></i>
                        </div>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div>
                        <div class="fs-7 text-dark fw-bold lh-2">${(player.matches_win/(player.matches == 0 ? 1 : player.matches)*100).toFixed(0)}%</div>
                        <div class="fs-8 text-gray-600 fw-bold lh-1 text-nowrap">Win Rate</div>
                    </div>
                    <!--end::Title-->
                </div>

                <div class="d-flex align-items-center me-2" data-toggle="tooltip" title="Kills per Death ratio">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-30px me-3">
                        <div class="symbol-label bg-transparent">
                            <i class="fad fa-skull fs-2 text-info"></i>
                        </div>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div>
                        <div class="fs-7 text-dark fw-bold lh-2">${(player.kills/(player.deaths == 0 ? 1 : player.deaths)).toFixed(2)}</div>
                        <div class="fs-8 text-gray-600 fw-bold lh-1">KDR</div>
                    </div>
                    <!--end::Title-->                    
                </div>

                <div class="d-flex align-items-center me-2" data-toggle="tooltip" title="Average Damage per Round">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-30px me-3">
                        <div class="symbol-label bg-transparent">
                            <i class="fad fa-meteor fs-2 text-primary"></i>
                        </div>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div>
                        <div class="fs-7 text-dark fw-bold lh-2">${(player.damage/(player.rounds == 0 ? 1 : player.rounds)).toFixed(2)}</div>
                        <div class="fs-8 text-gray-600 fw-bold lh-1">ADR</div>
                    </div>
                    <!--end::Title-->                    
                </div>
            </div>
        </div>

    `;

    html = $(html);
    
    html.data("steamid",steamid);

    router.updatePageLinks();

    return html;
}

export function renderByStatus(status, lobby = {}){
    console.log("rendering by status", status, LOBBY_STATUS[lobby.status]);
    $(".lobby-server-status").html(`${LOBBY_STATUS[lobby.status]}`);
    switch(status){
        case LOBBY_STATUS_CREATED:
            break;
        case LOBBY_STATUS_WAITING:
            break;
        case LOBBY_STATUS_READY:            
            $(".lobby-step-timer").html("");
            $(".lobby-step-container").text("Lobby is ready. Waiting few seconds to start Vetomap");
            lobbyTimer = new Countdown({displayElement: '.lobby-step-timer',
                seconds: 5,});
            lobbyTimer.start();
            break;
        case LOBBY_STATUS_VETOMAP:
            break;
        case LOBBY_STATUS_CONFIGURING:
            $(".lobby-step-container").html(`<span>Creating server and configuring game settings...</span><div class="spinner-border text-primary" role="status"></div>`);
            $(".lobby-step-timer").addClass("d-none");
            lobbyTimer == null ? lobbyTimer = new Countdown({displayElement: '.lobby-step-timer', seconds: 15}) : lobbyTimer.setSeconds(15);
            break;
        case LOBBY_STATUS_LAUNCHING:
            $(".lobby-step-container").html("Time to connect to the server...");
            $(".lobby-step-timer").removeClass("d-none");
            lobbyTimer == null ? lobbyTimer = new Countdown({displayElement: '.lobby-step-timer', seconds: 15}) : lobbyTimer.setSeconds(75);            
            
            $(".lobby-step-content").html(`
                <div class="card">
                    <div class="card-body">
                        <h5 class="text-gray-900 mb-0">Server</h5>
                        <div class="mb-4 fs-6 text-gray-700 w-100 cursor-default">
                            <img class="me-1" src="assets/media/flags/${lobby.serverInfo.location}.gif" style="vertical-align: middle"><span class="fw-bold text-gray-800 fs-7">${lobby.serverInfo.region}</span>
                        </div>
                        <h5 class="text-gray-900 mb-1">Map</h5>
                        <span class="btn mb-4 fs-7 text-gray-900 w-100 bgi-position-center bgi-size-cover cursor-default" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${lobby.maps[0]}.jpg');">${lobby.maps[0]}</span>
                        <div class="separator separator-dashed my-4"></div>
                        <h6 class="text-gray-900 mb-1 pt-2">Connect through the game console</h6>
                        <div class="input-group input-group-sm justify-content-center w-100 mb-6 flex-nowrap">
                            <span class="input-group-text bg-transparent w-250px text-gray-700"><span class="text-nowrap text-truncate text-hover-white cursor-pointer">connect ${lobby.serverInfo.server}</span></span>
                            <button type="button" class="btn btn-icon btn-outline btn-outline-light btn-sm clip" data-clipboard-text="connect ${lobby.serverInfo.server}">
                            
                            <span class="svg-icon svg-icon-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="currentColor"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="currentColor"></path>
                                </svg>
                            </span>
                                
                            </button>
                        </div>
                        <a href="steam://connect/${lobby.serverInfo.server}" class="btn btn-flex btn-light-primary border-hover-primary btn-active-primary btn-active-color-gray-100 external-handler w-100 justify-content-center">Join Server</a>
                    </div>
                </div>
            `);
            break;
        case LOBBY_STATUS_STARTED:
            break;
        case LOBBY_STATUS_PLAYING:
            break;
        case LOBBY_STATUS_FINISHED:
            break;
    }
}

export function renderTeamsDetailed(data){
    
        let teamA = data.teamA.map(steamid => renderPlayerDetailed(steamid, data));
        let teamB = data.teamB.map(steamid => renderPlayerDetailed(steamid, data));
    
        $(".team-A-container").html(teamA);
        $(".team-B-container").html(teamB);
    
        router.updatePageLinks();
}

function renderMapVeto(lobby, maps, turn = '', leaderTurn = ''){
    let host = lobby.creator === _user.me.steamid ? true : false;
    let leader = lobby.teamALeader === _user.me.steamid || lobby.teamBLeader === _user.me.steamid ? true : false;
    let team = lobby.teamA.includes(_user.me.steamid) ? "A" : lobby.teamB.includes(_user.me.steamid) ? "B" : "";
    let html = [];
    let votable = false;
    if(turn !== '' && turn === team && leader)
    {
        $(".lobby-step-container").text("Choose a map to veto");
        votable = true;
    }
    if(turn !== '' && turn !== team)
    {
        $(".lobby-step-container").text("Wait for the other team to veto a map");
    }
    if(turn !== '' && turn === team && !leader)
    {
        $(".lobby-step-container").text("Wait for the leader to veto a map");
    }
    maps.map(map => {
        html.push(`<span class="btn mb-2 fs-7 text-gray-900 w-100 bgi-position-center bgi-size-cover lobby-vote-map-option ${votable ? "votable" : "cursor-default"}" style="background-image: linear-gradient(to right, rgba(27, 27, 27, 0.4) 0px, rgb(27, 27, 27) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%),url('assets/media/maps/300px/${map}.jpg');" data-map="${map}" data-lobby-id="${lobby._id}">${map}</span>`);
    });
    $(".lobby-step-content").html(html);
    router.updatePageLinks();
}
    














export function renderLobbyButtons(data){

    let join = `<button type="button" class="btn btn-outline btn-outline-success lobby-join">Join Lobby</button>`;
    let leave = `<button type="button" class="btn btn-outline btn-outline-danger lobby-leave">Leave Lobby</button>`;
    let cancel = `<button type="button" class="btn btn-outline btn-outline-danger lobby-cancel">Cancel Lobby</button>`;
    let change = `<button type="button" class="btn btn-outline btn-outline-dark lobby-change-team me-4">Change Team</button>`;
    let play = `<button type="button" class="btn btn-sign btn-outline btn-outline-info">Join Lobby</button>`;
    let btns = `<button type="button" class="btn btn-outline btn-outline-success " disabled style="cursor: not-allowed">Join Lobby</button>`;

    if(!_user.authed){
        $(".lobby-buttons").html(play);
        return;
    }

    if(_user.inLobby)
    {
        if(_user.lobbyInfo !== undefined && _user.lobbyInfo._id == data._id)
        {
            if(_user.me.steamid === data.creator){
                $(".lobby-buttons").html(cancel);
            }
            else{
                $(".lobby-buttons").html(leave);
            }
            $(".lobby-buttons").prepend(change);
        }
        else
        {
            $(".lobby-buttons").html(btns);
        }

    }
    else
    {
        if(_user.me.steamid === data.creator){
            $(".lobby-buttons").html(cancel);
        }
        else
        {
            $(".lobby-buttons").html(join);
        }
    }

    $(".lobby-buttons").find("button").data("info", data);
    
    router.updatePageLinks();
}

export function renderFeatures(data) {

    let host = _user.me.steamid === data.creator ? true : false;
    let authed = _user.authed ? true : false;
    let imIn = data.players.hasOwnProperty(_user.me.steamid) ? true : false;
                    
    let ready = `<button type="button" class="mt-4 mb-2 btn btn-outline btn-outline-success w-100 bg-success bg-state-opacity-0 text-hover-success text-black lobby-player-ready">Ready</button>`;
    let start = `<button type="button" class="mt-4 mb-2 btn btn-outline btn-outline-primary w-100 bg-primary bg-state-opacity-0 text-hover-primary text-black lobby-host-start">Start</button>`;
    let btn = ``;

    if(authed)
    {
        //if(imIn) btn = host ? start : ready;
        if(imIn)
        {
            if(host)
            {
                btn = start;
            }
            else
            {
                if(!data.players[_user.me.steamid].ready)
                {
                    btn = ready;
                }
            }
        }
    }    

    $("#lobby-features-map-img").css("background-image", `url('assets/media/maps/400px/${data.maps[0]}.jpg')`);
    
    if(host){
        $("#lobby-map-ctrl").html(`
            <span class="btn btn-sm h-100 btn-icon bg-state-opacity-50 bg-state-light lobby-prev-map" style="position:absolute;left:0;top:50%;cursor: pointer;transform: translateY(-50%);"><i class="bi bi-caret-left fs-2 text-primary"></i></span>
            <span class="btn btn-sm h-100 btn-icon bg-state-opacity-50 bg-state-light lobby-next-map" style="position:absolute;right:0;top:50%;cursor: pointer;transform: translateY(-50%);"><i class="bi bi-caret-right fs-2 text-primary"></i></span>
        `);
    }

    $("#lobby-features-container").html(/*html*/`
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Map</div>
            <div id="lobby-features-map" class="fs-8 text-gray-900">${data.maps[0]}</div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Location</div>
            <div id="lobby-features-location" class="fs-8 text-gray-900">${data.region}</div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Ping</div>
            <div class="">
                <span class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="bi bi-bar-chart-fill text-success fs-8"></i> <span id="lobby-features-ping" data-showping="${data.location}">${_user.ping !== undefined ? (_user.ping[data.location] || 0) : 0}</span> <span>ms</span></span>
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Knife Round</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-knife-switch" ${data.knife ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-knife" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.knife ? 'on':'off'} text-primary fs-5 ${data.knife ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Overtime</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-ot-switch" ${data.ot ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-ot" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.ot ? 'on':'off'} text-primary fs-5 ${data.ot ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Friendly Fire</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-ff-switch" ${data.ff ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-ff" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.ff ? 'on':'off'} text-primary fs-5 ${data.ff ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>
        <div class="d-flex flex-stack">
            <div class="fs-7 fw-bold text-gray-700">Show Equip</div>
            <div class="">
                ${host ? `<div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input h-10px w-20px" type="checkbox" id="lobby-eq-switch" ${data.eq ? 'checked="checked"':''}/></div>`: `<span id="lobby-features-eq" class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="fas fa-toggle-${data.eq ? 'on':'off'} text-primary fs-5 ${data.eq ? '':'opacity-25'}"></i></span>`}
            </div>
        </div>

        ${btn}
    `);

    $("#lobby-map-ctrl").find('.lobby-prev-map').data("info", data);
    $("#lobby-map-ctrl").find('.lobby-next-map').data("info", data);
    $("#lobby-knife-switch").data("info", data);
    $("#lobby-ot-switch").data("info", data);
    $("#lobby-ff-switch").data("info", data);
    $("#lobby-eq-switch").data("info", data);    
    $("#lobby-features-container").find("button").data("info",data);
    router.updatePageLinks();
}

export function renderTeams(data){
    
    let teamA = []; 
    let teamB = [];

    data.teamA.map(steamid => {       
        teamA.push(renderPlayer(data.players[steamid], "A", steamid === data.creator ? true : false, data));
    });

    data.teamB.map(steamid => {        
        teamB.push(renderPlayer(data.players[steamid], "B", steamid === data.creator ? true : false, data));
    });

    if(teamA.length < parseInt(data.vs))
    {
        let num = parseInt(data.vs) - teamA.length - (teamB.length > parseInt(data.vs) ? (teamB.length - parseInt(data.vs)) : 0);
        for(let i = 0; i < num; i++)
        {
            teamA.push(renderSlot(data,"A"));
        }
    }

    if(teamB.length < parseInt(data.vs))
    {
        let num = parseInt(data.vs) - teamB.length - (teamA.length > parseInt(data.vs) ? (teamA.length - parseInt(data.vs)) : 0);
        for(let i = 0; i < num; i++)
        {
            teamB.push(renderSlot(data,"B"));
        }
    }

    console.log("teamA: ", teamA);
    console.log("teamB: ", teamB);

    $(".team-A-container").html("").append(teamA);
    $(".team-B-container").html("").append(teamB);
   
    router.updatePageLinks();
    KTMenu.createInstances(`[data-pmenu="true"]`);
}

export function renderPlayer(data, team, isCreator = false, lobby = {}){

    //console.log("rendering player", data);

    let host = _user.me.steamid === lobby.creator ? true : false;
    let authed = _user.authed ? true : false;
    let imIn = lobby.players.hasOwnProperty(_user.me.steamid) ? true : false;
        
    let me =  data.steamid === _user.me.steamid ? true : false;
    let crown = `<span class="badge badge-sm badge-secondary text-gray-100"><i class="fas fa-crown text-zyellow"></i></span>`;
    let ready = `<span class="badge badge-sm badge-success text-gray-100"><i class="bi bi-check-circle me-1"></i>Ready</span>`;
    let waiting = `<span class="d-flex align-items-center badge badge-sm badge-secondary text-success"><span class="spinner-border spinner-border-sm me-2" style="width: 0.9rem;height: 0.9rem;"></span>Waiting</span>`;

    let btn_player_menu = `<button class="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end h-auto w-auto" data-kt-menu-trigger="click" data-kt-menu-placement="${team == 'B' ? 'bottom-end' : 'bottom-start'}" data-kt-menu-overflow="true">    
        <span class="svg-icon svg-icon-1 svg-icon-gray-300  ${team == 'A' ? 'me-n1' : 'ms-n1'}">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/>
                <rect x="11" y="11" width="2" height="2" rx="1" fill="currentColor"/>
                <rect x="11" y="15" width="2" height="2" rx="1" fill="currentColor"/>
                <rect x="11" y="7" width="2" height="2" rx="1" fill="currentColor"/>
            </svg>
        </span>    
    </button>
    <div id="lobby-pmenu-${data._id}" class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-pmenu-${data._id}="true" data-kt-menu="true" data-pmenu="true" style="">
        <!--begin::Heading-->
        <div class="menu-item px-3">
            <div class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Actions</div>
        </div>
        <!--end::Heading-->
        
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <span class="menu-link flex-stack px-3 lobby-host-kick-player">Kick Player
            <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Specify a target name for future usage and reference" data-kt-initialized="1"></i></span>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <span class="menu-link flex-stack px-3 lobby-host-ban-player">Ban Player
            <i class="fas fa-ban ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Specify a target name for future usage and reference" data-kt-initialized="1"></i></span>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <span class="menu-link flex-stack px-3 lobby-host-change-team">Change Team
            <i class="fas fa-exchange-alt ms-2 fs-7" data-bs-toggle="tooltip" aria-label="Specify a target name for future usage and reference" data-kt-initialized="1"></i></span>
        </div>
        <!--end::Menu item-->
        
    </div>
    `;

    let state = ``;
    let pmenu = ``;

    if(isCreator)
    {
        state = crown;
    }
    else{
        if(data.ready == true)
        {
            state = ready;
        }
        else
        {
            state = waiting;
        }
    }

    if(host)
    {
        pmenu = isCreator ? "" : btn_player_menu;
    }
    
    let html = /* html */ `
    <div class="card ${me ? '' : "card-bordered"} bg-transparent mb-3" ${me ? `style="box-shadow: none;border: 1px solid rgb(255 143 0 / 75%);"` : ""}>
        <div class="d-flex flex-stack ${team == 'B' ? 'flex-row-reverse' : ''} py-3 px-3">
            <!--begin::Details-->
            <div class="d-flex align-items-center ${team == 'B' ? 'flex-row-reverse' : ''}">
                <!--begin::Avatar-->
                <div class="symbol symbol-40px">
                    <img alt="Pic" src="${data.avatar}">                    
                </div>
                <!--end::Avatar-->
                <!--begin::Details-->
                <div class="${team == 'B' ? 'me-4' : 'ms-4'} mw-150px text-truncate text-nowrap ${team == 'B' ? 'text-end' : ''}">
                    <a href="user/${data.communityid}" data-navigo class="fs-7 text-gray-900 mb-2 text-truncate text-nowrap player-nick"></a>
                    <div class="fw-bold text-muted fs-7">
                        <div class="d-flex justify-content-start align-items-center ${team == 'B' ? 'flex-row-reverse' : ''}">
                            <div class="d-flex ${team == 'B' ? 'ms-2' : 'me-2'}">
                                <a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white"><i class="fab fa-steam fs-3"></i></a>
                            </div>
                            <div class="symbol symbol-20px">
                                <img src="assets/media/roles/awper.png">
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::Details-->
            </div>
            <!--end::Details-->
            <!--begin::Lat seen-->
            <div class="d-flex flex-row align-items-center gap-2 ${team == 'A' ? "ms-2":"me-2"} ${team == 'B' ? "flex-row-reverse":""}">
                ${state}${pmenu}
            </div>
            <!--end::Lat seen-->
        </div>
    </div>    
    `;

    html = $(html);
    html.find(".player-nick").text(data.nickname);
    html.localize();    
    
    html.find(`#lobby-pmenu-${data._id}`);

    html.find(`.lobby-host-kick-player`).data("player", data);
    html.find(`.lobby-host-kick-player`).data("info", lobby);

    html.find(`.lobby-host-ban-player`).data("player", data);
    html.find(`.lobby-host-ban-player`).data("info", lobby);

    html.find(`.lobby-host-change-team`).data("player", data);
    html.find(`.lobby-host-change-team`).data("team", team);
    html.find(`.lobby-host-change-team`).data("info", lobby);
    

    router.updatePageLinks();

    return html;
}

export function renderSlot(data, team){
    //console.log(data);
    let html = /* html */ `<div class="card card-dashed bg-transparent mb-3 ${data.players.hasOwnProperty(_user.me.steamid) && data.players[_user.me.steamid].team == team ? '' : 'cursor-pointer lobby-take-slot'}">
                <div class="d-flex flex-stack ${team == 'B' ? 'flex-row-reverse' : ''} py-3 px-3">
                    <!--begin::Details-->
                    <div class="d-flex align-items-center ${team == 'B' ? 'flex-row-reverse' : ''}">
                        <!--begin::Avatar-->
                        <div class="symbol symbol-40px  align-self-center">
                            <i class="bi bi-plus-circle text-gray-300 fs-2tx"></i>
                        </div>
                        <!--end::Avatar-->
                        <!--begin::Details-->
                        <div class="${team == 'B' ? 'me-4' : 'ms-4'} mw-150px text-truncate text-nowrap ${team == 'B' ? 'text-end' : ''}">
                            <span class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">${data.players.hasOwnProperty(_user.me.steamid) && data.players[_user.me.steamid].team == team ? 'Empty Slot' : 'Take Slot'}</span>
                            <div class="fw-bold text-muted fs-7"></div>    
                        </div>
                        <!--end::Details-->
                    </div>
                    <!--end::Details-->
                    <!--begin::Lat seen-->
                    <div class="d-flex flex-column align-items-end me-2">
                        <div class="symbol symbol-40px">                                                                
                        </div>                            
                    </div>
                    <!--end::Lat seen-->
                </div>
            </div>`;
    
    html = $(html);
    html.data("info",data);
    html.data("team",team);
    html.localize();

    router.updatePageLinks();

    return html;
    
}


var clip = new ClipboardJS('.btn-copy');
clip.on('success', function (e) {
    
    e.clearSelection();
    if($(e.trigger).hasClass("copy-done")) return;
    let back = $(e.trigger).html();
    let backclass = $(e.trigger).attr("class");
    backclass = backclass.split(/\s+/);    
    backclass.map(cl => {$(e.trigger).removeClass(cl)});

    let fuckclass = "btn btn-sm btn-copy copy-done btn-icon btn-success";
    fuckclass = fuckclass.split(/\s+/);
    fuckclass.map(cl => {$(e.trigger).addClass(cl)});
    $(e.trigger).html(`<i class="bi bi-check fs-2x text-black"></i>`);

    var El = e.trigger;
    var popover = new bootstrap.Popover(El, {content: "Copied!", trigger: "manual"});
    popover.show();

    setTimeout(() => {
        fuckclass.map(cl => {$(e.trigger).removeClass(cl)});
        backclass.map(cl => {$(e.trigger).addClass(cl)});
        $(e.trigger).html(back);        
        popover.dispose();
    }, 2000);

  });





export default lobby;